export default __webpack_public_path__ + "static/media/Note@32.463a9e8f.svg";